module.exports = "/assets/4c1cb22362dfebaacf6f1187133da7ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/AS.png
// module id = 2335
// module chunks = 0